import { useMemo } from "react";
import { footerConfigSchema, defaultConfig } from "@core/model/footerModel";
import { parseSchema } from "@core/model/parseSchema";

export const useFooterConfig = () => {
  return useMemo(() => {
    const footerConfig = { ...defaultConfig, ...window.footerConfig };
    return parseSchema({
      schema: footerConfigSchema,
      rawData: footerConfig,
    });
  }, []);
};
